/**
 * Tracks which client-facing portal a user last signed into so the universal
 * /login chooser can skip the persona picker for returning users.
 *
 * Stored client-side only — it's a UX hint, not an authentication signal.
 * The portal-specific login pages still verify the user's role on the
 * server before granting access.
 */

const KEY = 'statbox:lastPortal'

export const PORTAL_IDS = ['community', 'academy', 'venue']

const PORTAL_LOGIN_PATH = {
  community: '/community/login',
  academy: '/academy/login',
  venue: '/venue-owner/login',
}

export function readLastPortal() {
  if (typeof window === 'undefined') return null
  try {
    const value = window.localStorage.getItem(KEY)
    return PORTAL_IDS.includes(value) ? value : null
  } catch {
    return null
  }
}

export function writeLastPortal(portal) {
  if (typeof window === 'undefined') return
  if (!PORTAL_IDS.includes(portal)) return
  try {
    window.localStorage.setItem(KEY, portal)
  } catch {
    // localStorage may be unavailable (private mode, quota); ignore.
  }
}

export function clearLastPortal() {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.removeItem(KEY)
  } catch {
    // ignore
  }
}

export function loginPathForPortal(portal) {
  return PORTAL_LOGIN_PATH[portal] || null
}
